import { useState } from "react";
import { CATEGORY_LABELS, MARKET_LABELS, type Signal } from "@shared/schema/signal";
import { directionGlyph, formatChange, formatTime } from "../lib";
import { SignalStrength } from "./SignalStrength";
import { SignalDetail } from "./SignalDetail";

export function SignalRow({ signal }: { signal: Signal }) {
  const [open, setOpen] = useState(false);
  return (
    <article className={`signal-row ${open ? "is-open" : ""}`}>
      <button className="signal-row-main" type="button" onClick={() => setOpen((value) => !value)} aria-expanded={open}>
        <time>{formatTime(signal.timestamp)}</time>
        <div className="signal-copy">
          <strong>{signal.title}</strong>
          <span>{CATEGORY_LABELS[signal.category]} · {MARKET_LABELS[signal.market]} · {signal.source.name}</span>
        </div>
        <div className="signal-value"><strong>{signal.displayValue}</strong><span>{formatChange(signal.change1d)}</span></div>
        <span className={`direction direction-${signal.direction}`}>{directionGlyph(signal.direction)}</span>
        <SignalStrength value={signal.strength} />
        <span className="expand-glyph" aria-hidden="true">{open ? "−" : "+"}</span>
      </button>
      {open ? <SignalDetail signal={signal} /> : null}
    </article>
  );
}
